/**
 * @file Aliyun OSS 签名获取
 * @author svon.me@gmail.com
 */

import {API} from "@js-lion/api";
import safeGet from "@fengqiaogang/safe-get";

export enum UploadOrigin {
  Multipart = "ali-multi", // 阿里云大文件上传
  Simple = "ali-simple"    // 阿里云小文件上传
}

export class Signature {
  accessId!: string;     // AliOSS accessKeyId
  accessKey!: string;    // AliOSS accessKey
  // 上传路径
  dir!: string;
  // Ali OSS  Bucket 名称
  containerName!: string;
  // 上传域名地址
  host!: string;
  // 签名
  securityToken!: string;
  // 文件名
  fileName?: string;
  // Bucket 所在地域
  region!: string;
  // 预览地址
  url?: string;
  path?: string;
  origin!: UploadOrigin
}

export const getSignature = async function (file?: File, headers: object = {}, body: object = {}): Promise<Signature | undefined> {
  const api: API = new API();
  const fileSize = file ? Math.ceil(file.size / 1024) : 0;
  let res;
  try {
    const value = {
      ...body,
      fileSize,
      fileName: file?.name
    };
    res = await api.post("/lqa-game/system/project/common/getOssAuth", value, {headers});
  } catch (e) {
    return void 0;
  }
  const data = safeGet<object>(res, "data");
  const sign = new Signature();
  if (data) {
    sign.origin = safeGet<UploadOrigin>(data, "origin") || UploadOrigin.Simple;
    sign.host = safeGet<string>(data, "host")!;
    sign.dir = safeGet<string>(data, "dir")!;
    sign.accessId = safeGet<string>(data, "accessId")!;
    sign.accessKey = safeGet<string>(data, "accessKey")!;
    sign.fileName = safeGet<string>(data, "fileName") || file?.name.replace(/[\s+=#&]/ig, "");

    sign.securityToken = safeGet<string>(data, "securityToken")!;
    sign.containerName = safeGet<string>(data, "containerName")!;
    sign.region = safeGet<string>(data, "region")!;

    sign.path = `${sign.dir}${sign.fileName}`;
    //sign.url = `/out/images/${sign.path}`;
    sign.url = `/${sign.path}`;
  }
  return sign;
}